<template>
  <div class="investment-form">
    <div class="header">
      Comprobante de domicilio <div @click="$emit('openStep')"><span class="mdi mdi-chevron-down"></span></div>
    </div>
    <div class="form">
      <div class="id-container">
        <div class="id-data">
          <div class="id-note">
            Si tu dirección personal no coincide con la que aparece en tu identificación oficial es
            necesario que también nos proporciones tu comprobante de domicilio.
          </div>
          <div class="id-subheader">Comprobantes aceptados:</div>
          <div class="id-option">• Recibo de luz</div>
          <div class="id-option">• Recibo de agua</div>
          <div class="id-option">• Recibo de teléfono/internet</div>
        </div>
        <div class="id-upload">
          <div class="upload-button">
            <img v-if="idBase64" :src="`data:image/jpg;base64, ${idBase64}`" accept="image/jpeg">
            <img v-else src="/upload-files.svg">
            <input v-if="!loading" type="file" accept="image/*" @change="processFile($event, 'address')"/>
            <div v-else>Cargando...</div>
          </div>
        </div>
      </div>
    </div>
    <div class="button-wrapper">
      <div class="button" @click="$emit('next')">
        Siguiente
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import axios from 'axios';

const { mapState } = createNamespacedHelpers('user');

export default {
  data() {
    return {
      data: {},
      idBase64: null,
      loading: false,
    };
  },
  watch: {
    user() {
      this.data = { ...this.user };
      if (this.data.proofOfAddressUrl) {
        this.loading = true;
        this.loadImage();
      }
    },
  },
  methods: {
    async processFile(event, type) {
      const fd = new FormData();
      const file = event.target.files[0];
      const url = `${process.env.VUE_APP_SERVER_URL}/upload/${type}`;
      fd.append('image', file);
      this.loading = true;
      await axios.post(url, fd);
      this.loadImage();
    },
    async loadImage() {
      const { data } = await axios.get(`${process.env.VUE_APP_SERVER_URL}/user/address`);
      this.idBase64 = data;
      this.loading = false;
    },
  },
  computed: {
    ...mapState([
      'user',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.investment-form {
  display: flex;
  flex-wrap: wrap;
}
.header {
  width: 100%;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.form {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
/deep/ .form-input {
  font-size: 15px;
  border: none;
  border: 1px solid #d6d6d8;
  padding: 8px;
  font-family: inherit;
  width: 100%;
  border-radius: 4px;

  &:focus {
    border: 1px solid #3479e9;
  }
}
.id-container {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
}
.id-data {
  width: 50%;
}
.id-header {
  width: 100%;
  font-weight: bolder;
  font-size: 20px;
  margin-bottom: 20px;
}
.id-subheader {
  font-size: 16px;
  margin-bottom: 12px;
}
.id-option {
  & + .id-option {
    margin-top: 8px;
  }
  & + .id-note {
    margin-top: 16px;
  }
}
.id-note {
  line-height: 20px;

  & + .id-subheader {
    margin-top: 20px;
  }
}
.id-upload {
  width: 50%;
  display: flex;
  justify-content: center;
}
.upload-button {
  width: 30%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 15px;

  img {
    width: 100%;
    margin-bottom: 10px;
  }
}
.button-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
}
.button {
  background-color: #3479e9;
  color: white;
  padding: 12px 40px;
  font-size: 16px;
  border-radius: 4px;
  cursor: pointer;
}
</style>
